import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import useProductUrl from '../../../hooks/useProductUrl';
import ProductDetailLink from '../../../components/ProductDetailLink';
import type { ProductAlternative } from '../../../@sprinx/knihovka-types';

export interface ProductDetailAlternativeRowProps extends StandardDivProps<ProductDetailAlternativeRowClassKey> {
  product: ProductAlternative;
}

export type ProductDetailAlternativeRowClassKey = 'root' | 'name';

const themeSettings = { name: 'ProductDetailAlternativeRow' };
const useStyles = makeStyles(
  () =>
    createStyles<ProductDetailAlternativeRowClassKey, {}>({
      root: {},
      name: {},
    }),
  themeSettings,
);

const ProductDetailAlternativeRow = React.forwardRef<HTMLDivElement, ProductDetailAlternativeRowProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const t = useTranslateWithFallback();
    const to = useProductUrl(product);

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <ProductDetailLink className={classes.name} to={to} variant='inherit'>
          <span>{t(product.name, { acceptString: true })}</span>
          <span>{` (${product.sku})`}</span>
        </ProductDetailLink>
      </div>
    );
  },
);

ProductDetailAlternativeRow.displayName = 'ProductDetailAlternativeRow';

export default withThemeProps(themeSettings)(ProductDetailAlternativeRow);
